export function getUserProperties(user) {
    return {
        email: user.get('email'),
        name: `${user.get('firstName')} ${user.get('lastName')}`,
        gender: user.get('gender'),
        roles: user.get('roles') || [],
        emailVerified: user.get('emailVerified'),
        tosAgreeDate: user.get('tosAgreeDate'),
        tags: user.get('tags') || [],
        lastOrderedAt: user.get('lastOrderedAt'),
        phone: user.get('phone'),
        address: user.get('address'),
        addressLine2: user.get('addressLine2'),
        city: user.get('city'),
        state: user.get('state'),
        postalCode: user.get('postalCode'),
        country: user.get('country')
    };
}
